import { render, staticRenderFns } from "./ViewScopingAnalysisOfData.vue?vue&type=template&id=c304a898&scoped=true"
import script from "./ViewScopingAnalysisOfData.vue?vue&type=script&lang=js"
export * from "./ViewScopingAnalysisOfData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c304a898",
  null
  
)

export default component.exports